import { render, staticRenderFns } from "./rules-form.vue?vue&type=template&id=25212f77&scoped=true"
import script from "./rules-form.vue?vue&type=script&lang=js"
export * from "./rules-form.vue?vue&type=script&lang=js"
import style0 from "./rules-form.vue?vue&type=style&index=0&id=25212f77&prod&lang=less&scoped=true"
import style1 from "./rules-form.vue?vue&type=style&index=1&id=25212f77&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25212f77",
  null
  
)

export default component.exports